import React, { useContext } from 'react'
import { useStaticQuery, graphql, Link } from 'gatsby'

import Layout from '../components/Layout'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import LandingPage from '../components/LandingPage'
import oct from '../assets/images/octblob.svg'
import lightoct from '../assets/images/octbloblight.svg'
import xlwaves from '../assets/images/xlwaves.svg'
import xlwaveslight from '../assets/images/xlwaveslight.svg'
import FontContext from '../context/fontsize/fontContext'
import Hidden from '@material-ui/core/Hidden'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import Button from '@material-ui/core/Button'
import { BsArrowRight } from 'react-icons/bs'
import Seo from '../components/Seo'

const useStyles = makeStyles((theme) => ({
	btn: {
		width: '47.5em',
		height: '3.5em',
		borderRadius: 0,
		'&:hover': {
			backgroundColor: '#393e46',
		},
		[theme.breakpoints.down('sm')]: {
			width: '22.5em',
		},
		[theme.breakpoints.down('xs')]: {
			width: '100vw',
		},
	},
	lightBtn: {
		width: '47.5em',
		height: '3.5em',
		borderRadius: 0,
		'&:hover': {
			backgroundColor: '#fff',
		},
		[theme.breakpoints.down('sm')]: {
			width: '22.5em',
		},
		[theme.breakpoints.down('xs')]: {
			width: '100vw',
		},
	},
}))

const IndexPage = () => {
	const data = useStaticQuery(graphql`
		query SiteQuery {
			site {
				siteMetadata {
					title
					description
					author
				}
			}
		}
	`)
	let { title, description, author } = data.site.siteMetadata
	const classes = useStyles()
	const theme = useTheme()
	const fontContext = useContext(FontContext)
	const { darkMode } = fontContext
	const matchesSM = useMediaQuery(theme.breakpoints.down('sm'))
	const matchesXS = useMediaQuery(theme.breakpoints.down('xs'))
	return (
		<Layout>
			<Seo title='Home' />
			<Hidden smUp>
				<div
					style={{
						position: 'absolute',
						top: 0,
						backgroundImage: darkMode ? `url(${oct})` : `url(${lightoct})`,
						objectPosition: 'cover',
						backgroundRepeat: 'no-repeat',
						height: '100vh',
						padding: 0,
					}}
				>
					<Grid
						container
						justify='center'
						style={{
							paddingTop: '8.5em',
						}}
					>
						<LandingPage
							title={title}
							description={description}
							author={author}
						/>
						<Grid
							item
							xs={12}
							sm={6}
							lg={12}
							style={{
								paddingTop: matchesXS ? '.5em' : '2em',
								paddingBottom: '3em',
							}}
						>
							<Grid container justify='center'>
								<Link to='/articles' style={{ textDecoration: 'none' }}>
									<Button
										variant='contained'
										className={darkMode ? classes.btn : classes.lightBtn}
										color='primary'
										disableRipple
										disableElevation={darkMode ? true : false}
									>
										View all articles{' '}
										<BsArrowRight size={20} style={{ marginLeft: '.5em' }} />
									</Button>
								</Link>
							</Grid>
						</Grid>
					</Grid>
				</div>
			</Hidden>
			<Hidden xsDown>
				<div
					style={{
						position: 'absolute',
						top: 0,
						backgroundImage: darkMode
							? `url(${xlwaves})`
							: `url(${xlwaveslight})`,
						objectPosition: 'cover',
						backgroundRepeat: 'no-repeat',
						height: '100vh',
						width: matchesSM ? 'calc(100% - 175px)' : 'calc(100% - 220px)',
						padding: 0,
					}}
				>
					<Grid
						container
						justify='center'
						style={{
							paddingTop: '8.5em',
						}}
					>
						<LandingPage
							title={title}
							description={description}
							author={author}
						/>
						<Grid
							item
							xs={12}
							sm={6}
							lg={12}
							style={{
								paddingTop: matchesXS ? '.5em' : '2em',
								paddingBottom: '3em',
							}}
						>
							<Grid container justify='center'>
								<Link to='/articles' style={{ textDecoration: 'none' }}>
									<Button
										variant='contained'
										className={darkMode ? classes.btn : classes.lightBtn}
										color='primary'
										disableRipple
										disableElevation={darkMode ? true : false}
									>
										View all articles{' '}
										<BsArrowRight size={20} style={{ marginLeft: '.5em' }} />
									</Button>
								</Link>
							</Grid>
						</Grid>
					</Grid>
				</div>
			</Hidden>
		</Layout>
	)
}

export default IndexPage
